import { Component, ElementRef, HostListener, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import SignaturePad from 'signature_pad';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-modal-assignature',
  templateUrl: './modal-assignature.component.html',
  styleUrls: ['./modal-assignature.component.css']
})
export class ModalAssignatureComponent implements OnInit {

  @ViewChild('canvas', { static: true }) signaturePadElement;
  signaturePad?: any;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private elementRef: ElementRef,
    public dialog: MatDialogRef<ModalAssignatureComponent>
    ) { }

  ngOnInit(): void {
    this.signaturePad = new SignaturePad(this.signaturePadElement.nativeElement);
    this.signaturePad.clear();
    this.signaturePad.penColor = 'rgb(0,0,0)';
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.init();
  }
  init() {
    const canvas: any = this.elementRef.nativeElement.querySelector('canvas');
    canvas.width = window.innerWidth;
    if (this.signaturePad) {
      this.signaturePad.clear(); // Clear the pad on init
    }
  }

  clear() {
    this.signaturePad.clear();
  }

  undo() {
    const data = this.signaturePad.toData();
    if (data) {
      data.pop(); // remove the last dot or line
      this.signaturePad.fromData(data);
    }
  }
  isCanvasBlank(): boolean {
    if (this.signaturePad) {
      return this.signaturePad.isEmpty() ? true : false;
    }
  }

  send(){
    if(this.signaturePad.toDataURL() != ''){
      Swal.fire('', 'Assinatura salva com sucesso!', 'success');
      this.dialog.close(this.signaturePad.toDataURL());
    }
  }
}
